import React, { Component } from "react";

import intro from "../../Images/intro.png";
import no from "../../Images/no.png";
import yes from "../../Images/yes.png";

import world from "../../Images/world.png";
import world_04 from "../../Images/world_04.png";
import world_05 from "../../Images/world_05.png";
import world_06 from "../../Images/world_06.png";
import world_green from "../../Images/world_green.png";

import next from "../../Images/next-button.png";

import animal_01_big from "../../Images/animal_01_big.png";
import animal_02_big from "../../Images/animal_02_big.png";
import animal_03_big from "../../Images/animal_03_big.png";
import animal_04_big from "../../Images/animal_04_big.png";
import animal_05_big from "../../Images/animal_05_big.png";
import animal_06_big from "../../Images/animal_06_big.png";
import animal_07_big from "../../Images/animal_07_big.png";
import animal_08_big from "../../Images/animal_08_big.png";

import animal_01 from "../../Images/animal_01.png";
import animal_02 from "../../Images/animal_02.png";
import animal_03 from "../../Images/animal_03.png";
import animal_04 from "../../Images/animal_04.png";
import animal_05 from "../../Images/animal_05.png";
import animal_06 from "../../Images/animal_06.png";
import animal_07 from "../../Images/animal_07.png";
import animal_08 from "../../Images/animal_08.png";

import textImg from "./H1_tekstblok antwoord.png";

import "./DeDieren.scss";

class DeDieren extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_answer: false,
      guess: null,
      animal: {
        index: 0,
        name: "Anaconda",
        world: world_green,
        big_img: animal_01_big,
        img: animal_01,
        answer: true,
        answer_yes:
          "Juist! De anaconda is een wurgslang. Hij wordt door sommige gemeenschappen in het Amazonewoud als een soort god aanzien!",
        answer_no:
          "Fout! De anaconda is een wurgslang. Hij wordt door sommige gemeenschappen in het Amazonewoud als een soort god aanzien!"
      },
      animals: [
        {
          index: 0,
          name: "Anaconda",
          world: world_green,
          big_img: animal_01_big,
          img: animal_01,
          answer: true,
          answer_yes:
            "Juist! De anaconda is een wurgslang. Hij wordt door sommige gemeenschappen in het Amazonewoud als een soort god aanzien!",
          answer_no:
            "Fout! De anaconda is een wurgslang. Hij wordt door sommige gemeenschappen in het Amazonewoud als een soort god aanzien!"
        },
        {
          index: 1,
          name: "Roze Dolfijn",
          world: world_green,
          big_img: animal_02_big,
          img: animal_02,
          answer: true,
          answer_yes: "Juist! Deze kleine dolfijn leeft in de Amazonerivier.",
          answer_no: "Fout! Deze kleine dolfijn leeft in de Amazonerivier."
        },
        {
          index: 2,
          name: "Jaguar",
          world: world_green,
          big_img: animal_03_big,
          img: animal_03,
          answer: true,
          answer_yes:
            "Juist! De jaguar is de grootste katachtige van Amerika. Hij kan tot wel 80 km/u lopen!",
          answer_no:
            "Fout! De jaguar is de grootste katachtige van Amerika. Hij kan tot wel 80 km/u lopen!"
        },
        {
          index: 3,
          name: "Leeuw",
          world: world_04,
          big_img: animal_04_big,
          img: animal_04,
          answer: false,
          answer_yes:
            "Juist! Er bestaan 2 soorten leeuwen: de Afrikaanse en de Aziatische.",
          answer_no:
            "Fout! Er bestaan 2 soorten leeuwen: de Afrikaanse en de Aziatische."
        },
        {
          index: 4,
          name: "Oran-Oetang",
          world: world_05,
          big_img: animal_05_big,
          img: animal_05,
          answer: false,
          answer_yes:
            "Juist! Orang-oetans leven in Zuidoost-Azië. Ze zijn mensapen die graag in bomen leven. Ze bouwen elke dag een nieuw nest, dat op wel 30 meter boven de grond kan zijn!",
          answer_no:
            "Fout! Orang-oetans leven in Zuidoost-Azië. Ze zijn mensapen die graag in bomen leven. Ze bouwen elke dag een nieuw nest, dat op wel 30 meter boven de grond kan zijn!"
        },
        {
          index: 5,
          name: "Otter",
          world: world_06,
          big_img: animal_06_big,
          img: animal_06,
          answer: false,
          answer_yes:
            "Juist! De otter leeft in Europa en Azië. Otters kunnen 8 uur na elkaar blijven zwemmen!",
          answer_no:
            "Fout! De otter leeft in Europa en Azië. Otters kunnen 8 uur na elkaar blijven zwemmen!"
        },
        {
          index: 6,
          name: "Papegaai",
          world: world_green,
          big_img: animal_07_big,
          img: animal_07,
          answer: true,
          answer_yes:
            "Juist! Deze blauwgele ara leeft in het Amazonewoud en heeft veren die bovenaan blauw zijn, en onderaan geel!",
          answer_no:
            "Fout! Deze blauwgele ara leeft in het Amazonewoud en heeft veren die bovenaan blauw zijn, en onderaan geel!"
        },
        {
          index: 7,
          name: "Piranha",
          world: world_green,
          big_img: animal_08_big,
          img: animal_08,
          answer: true,
          answer_yes:
            "Juist! Wist je dat piranha’s naast fruit ook vlees eten? Daarom hebben ze zo scherpe tanden.",
          answer_no:
            "Fout! Wist je dat piranha’s naast fruit ook vlees eten? Daarom hebben ze zo scherpe tanden."
        },
        {
          index: 8,
          name: "Einde",
          world: world_green,
          big_img: animal_08_big,
          img: animal_08,
          answer: true,
          answer_yes:
            "Nu je weet welke dieren in het Amazonewoud leven, ben je klaar voor het tweede hoofdstuk!",
          answer_no:
            "Nu je weet welke dieren in het Amazonewoud leven, ben je klaar voor het tweede hoofdstuk!"
        }
      ]
    };
  }
  render() {
    const { animal, animals, show_answer, guess } = this.state;
    return (
      <div className="de-dieren">
        <img
          src={show_answer ? animal.world : world}
          className="world"
          alt="Wereldkaart"
        />
        <div className="upper_layer">
          <div className="intro">
            <img src={intro} alt="Introductie" />
            <span>Leven deze dieren in het Amazonewoud?</span>
          </div>
          {!show_answer && (
            <div className="yes_no">
              <img
                src={no}
                className="no"
                alt="Nee"
                onClick={() => {
                  this.setState({
                    show_answer: true,
                    guess: !animal.answer
                  });
                }}
              />
              <img src={animal.big_img} className="animal_big" alt="Dier" />
              <img
                src={yes}
                className="no"
                alt="Ja"
                onClick={() => {
                  this.setState({
                    show_answer: true,
                    guess: animal.answer
                  });
                }}
              />
              <span>{animal.name}</span>
            </div>
          )}
          {show_answer && (
            <div
              className="answer"
              style={{
                backgroundImage: `url(${textImg})`,
              }}
            >
              <span>{guess ? animal.answer_yes : animal.answer_no}</span>
            </div>
          )}
          {(show_answer && (animal.index < 7)) && (
            <img
              src={next}
              className="next"
              alt="next"
              onClick={()=>{
                this.setState({
                  animal: animals[animal.index + 1],
                  show_answer: false
                });
              }}
            />
          )}
          {(show_answer && (animal.index == 7)) && (
            <img
              src={next}
              className="next"
              alt="next"
              onClick={()=>{
                this.setState({
                  animal: animals[animal.index + 1],
                  show_answer: true
                });
              }}
            />
          )}
          <div className="animals">
            {animals.map(an => {
              if(an.index == 8) return
              return (
                <img
                  src={an.img}
                  className={
                    an.name === animal.name ? "animal selected" : "animal"
                  }
                  alt={an.name}
                  onClick={() => {
                    this.setState({
                      animal: an,
                      show_answer: false
                    });
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default DeDieren;
